import { format } from 'date-fns'
import { keyBy } from 'lodash'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    byDate: {},
    busy: false,
  },
  mutations: {
    set(state, data) {
      state.byDate = keyBy(data, 'date')
    },
    busy(state, busy = false) {
      state.busy = busy
    },
  },
  actions: {
    async get(
      {
        commit,
        rootState: { reception },
      },
      { date, courseId },
    ) {
      commit('busy', true)

      const res = await POST(`/${reception.segment}/api/web/reception/calendar`, {
        date: format(date, 'YYYY-MM-DD'),
        sync_course_id: courseId,
      })
      if (res.status === 200) {
        commit('set', res.data.calendar)
      } else {
        commit('error/message', res.message, { root: true })
      }

      commit('busy', false)
      return res.status === 200
    },
  },
}
